import React from 'react'
import './Styles.css'

const FunctionalityCard = ({ image, title, description }) => {
  return (
    <div className="functionality-card">
      <img className="image" src={image} alt="functionality" />
      <p className="label">{title}</p>
      <p className="description">{description}</p>
    </div>
  )
}

export default FunctionalityCard
